import { useParams } from 'react-router';

import AddContentObjectContainer from './AddContentObjectContainer';

const testId = 'add-content-object';
interface AddContentObjectProps {
  /**
   * If object is duplicating
   */
  duplicate?: boolean;
  /**
   * Content Object mode
   */
  mode?: string;
}

const AddContentObject = ({
  duplicate = false,
  mode = '',
}: AddContentObjectProps) => {
  const { contentTypeName, id } = useParams();
  return (
    <AddContentObjectContainer
      contentTypeName={contentTypeName}
      id={id}
      duplicate={duplicate}
      mode={mode}
      testId={testId}
    />
  );
};

export default AddContentObject;
